import React from 'react';

const BackgroundAnimatedGrid = () => (
    <svg preserveAspectRatio="none" viewBox="0 0 1400 800" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeOpacity="0.2"
            transform="translate(-980.000000, -384.000000)"
            stroke="#0000FF"
        >
            <g transform="translate(2401.000000, 51.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(2500.000000, 25.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(2600.000000, 0.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(2300.000000, 75.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(2200.000000, 100.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(2100.000000, 125.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(2000.000000, 150.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(1900.000000, 175.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(1800.000000, 200.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(1700.000000, 224.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(1600.000000, 250.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(1500.000000, 275.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(1400.000000, 300.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(1300.000000, 325.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(1200.000000, 350.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(1100.000000, 376.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(1000.000000, 400.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <g transform="translate(800.000000, 450.000000)">
                <polyline points="600 1000 1.54390389e-13 583.333333 1.11022302e-13 0"></polyline>
            </g>
            <path d="M1500,1558 L3500.07507,1058"></path>
            <path d="M1400,1483.08333 L3392.07507,984.083333"></path>
            <path d="M1299,1408.16667 L3291.07507,909.166667"></path>
            <path d="M1200,1333.25 L3192.07507,834.25"></path>
            <path d="M1100,1258.33333 L3092.07507,759.333333"></path>
            <path d="M1000,1184.41667 L2992.07507,685.416667"></path>
            <path d="M900,1109.5 L2892.07507,610.5"></path>
            <path d="M800,1033.58333 L2792.07507,534.583333"></path>
            <path d="M700,957.666667 L2692.07507,458.666667"></path>
            <path d="M600,882.75 L2592.07507,383.75"></path>
            <path d="M500,807.833333 L2492.07507,308.833333"></path>
            <path d="M400,732.916667 L2392.07507,233.916667"></path>
            <path d="M300,658 L2292.07507,159"></path>
        </g>
    </svg>
);

export default BackgroundAnimatedGrid;
